import { useEffect } from "react";

/**
 * Registra el service worker de shell PWA en producción — Structura Food Market.
 * Respeta el flag global de plataforma `pwa_enabled` (control SaaS desde admin):
 * si el super_admin lo apaga, desregistra el SW existente.
 */
export function PwaRegistration() {
  useEffect(() => {
    const enable = import.meta.env.PROD || import.meta.env.VITE_ENABLE_PWA === "1";
    if (!enable) return;
    if (!("serviceWorker" in navigator)) return;

    let cancelled = false;
    void fetch("/api/platform-flags", { cache: "no-store", credentials: "same-origin" })
      .then((r) => (r.ok ? r.json() : null))
      .then((d: { flags?: { pwa_enabled?: boolean } } | null) => {
        if (cancelled) return;
        const pwaEnabled = d?.flags?.pwa_enabled !== false; // default ON
        if (pwaEnabled) {
          void navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => undefined);
        } else {
          void navigator.serviceWorker.getRegistrations().then((regs) => {
            for (const reg of regs) void reg.unregister();
          });
        }
      })
      .catch(() => {
        void navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => undefined);
      });
    return () => { cancelled = true; };
  }, []);
  return null;
}
